import { useState } from 'react';
import { Box, Button, Paper, Step, StepLabel, Stepper } from '@mui/material';
import { useParams } from 'react-router-dom';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import ResultFiltration from './ResultFiltration';
import { reportSteps } from './types';
import InterpretationPage from './Interpretation/InterpretationPage';
import ReportPage from './Interpretation/Report/ReportPage';

const renderStepContent = (step: number, outputID: string) => {
  switch (step) {
    case 0:
      return (
        <ResultFiltration outputID={outputID} allowValidateVariant={false} />
      );
    case 1:
      return (
        <InterpretationPage
          outputID={outputID}
          allowValidateVariant
          allowRejectVariant={false}
          personStatus="User 1" // FOR TESSTING: LATER WILL BE REPLACE BY ENDPOINT(PIPELINE CONFIG)
        />
      );
    case 2:
      return (
        <InterpretationPage
          outputID={outputID}
          allowValidateVariant
          allowRejectVariant
          personStatus="User 2" // FOR TESSTING: LATER WILL BE REPLACE BY ENDPOINT(PIPELINE CONFIG)
        />
      );
    case 3:
      return <div>Preview validation</div>;
    case 4:
      return <ReportPage outputID={outputID} />;
    default:
      return <div>Unknown step</div>;
  }
};

const ResultPage = () => {
  const { outputID } = useParams<{ outputID: string }>();
  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    if (activeStep < reportSteps.length - 1) setActiveStep((prev) => prev + 1);
  };

  const handleBack = () => {
    if (activeStep > 0) setActiveStep((prev) => prev - 1);
  };

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 0,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      {/* Stepper Bar */}
      <Paper
        elevation={3}
        sx={{
          mb: 2, // add space between Paper and next element
          height: '6rem',
          display: 'flex',
          alignItems: 'center',
          mt: 1,
          mx: 2, // shorthand for ml + mr
          px: 6,
          backgroundColor: 'background.paper',
          zIndex: 5,
          borderBottom: '1px solid',
          borderColor: 'divider',
          position: 'sticky',
          top: 0,
        }}
      >
        <Box sx={{ display: 'flex', gap: 1, ml: 4 }}>
          <Button
            startIcon={<ArrowBack />}
            onClick={handleBack}
            disabled={activeStep === 0}
            variant="outlined"
          >
            Back
          </Button>
        </Box>
        <Stepper activeStep={activeStep} alternativeLabel sx={{ flex: 1 }}>
          {reportSteps.map((label, index) => (
            <Step key={label}>
              <StepLabel
                onClick={() => setActiveStep(index)}
                sx={{
                  cursor: 'pointer',
                  '& .MuiStepLabel-label': {
                    fontSize: '0.875rem',
                  },
                }}
              >
                {label}
              </StepLabel>
            </Step>
          ))}
        </Stepper>

        {/* Navigation Buttons */}
        <Box sx={{ display: 'flex', gap: 1, ml: 4 }}>
          <Button
            endIcon={<ArrowForward />}
            onClick={handleNext}
            disabled={activeStep === reportSteps.length - 1}
            variant="contained"
          >
            Next
          </Button>
        </Box>
      </Paper>

      {/* Step Content */}
      <Box
        sx={{
          flex: 1,
          overflow: 'hidden', // Prevent double scrollbars
          display: 'flex',
          flexDirection: 'column',
          backgroundColor: 'background.default',
        }}
      >
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            p: 2,
          }}
        >
          {renderStepContent(activeStep, outputID!)}
        </Box>
      </Box>
    </Box>
  );
};

export default ResultPage;
